import { z } from 'zod';
/**
 * Standard error response schema
 */
export const ErrorResponseSchema = z.object({
    error: z.string().describe('Error type or code'),
    message: z.string().describe('Human-readable error message'),
    timestamp: z.iso.datetime().describe('Error timestamp in ISO format'),
    statusCode: z.number().describe('HTTP status code'),
    details: z.looseObject({}).optional().describe('Additional error details and context'),
});
//# sourceMappingURL=ErrorResponse.js.map